import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { FaelligkeitFeld, ZuweisungFeld } from './AufgabenFelder';
import { faelligkeitAusWert, faelligkeitHeute, faelligkeitWert, type Faelligkeit } from '../../lib/faelligkeit';

export interface TaskFormValues {
  title?: string;
  description?: string;
  dueAt: string; // yyyy-mm-dd HH:mm:00 (Ortszeit), ohne Uhrzeit 23:59
  assignedUserId: number;
  personHistoryId?: number;
  standortId?: number;
}

/**
 * Aufgabe anlegen oder bearbeiten — mit denselben Feldern wie in den Assistenten
 * (T-0057): Fälligkeit als Datum, Uhrzeit nur auf Wunsch.
 */
export const TaskForm: React.FC<{
  initial?: Partial<TaskFormValues>;
  onSubmit: (values: TaskFormValues) => void;
  onCancel?: () => void;
  users?: Array<{ id: number; name: string }>;
}> = ({ initial, onSubmit, onCancel, users = [] }) => {
  const [title, setTitle] = useState(initial?.title || '');
  const [description, setDescription] = useState(initial?.description || '');
  const [faelligkeit, setFaelligkeit] = useState<Faelligkeit>(
    initial?.dueAt ? faelligkeitAusWert(initial.dueAt) : faelligkeitHeute(),
  );
  const [assignedUserId, setAssignedUserId] = useState<number>(initial?.assignedUserId || 0);
  const [personHistoryId] = useState<number | undefined>(initial?.personHistoryId);
  const [standortId] = useState<number | undefined>(initial?.standortId);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!title.trim() || !faelligkeit.datum) return;
    if (!assignedUserId || assignedUserId <= 0) return;
    onSubmit({
      title: title.trim(),
      description: description || undefined,
      dueAt: faelligkeitWert(faelligkeit),
      assignedUserId,
      personHistoryId,
      standortId,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="grid gap-4">
      <div className="grid gap-2">
        <Label htmlFor="aufgabe-titel">Titel</Label>
        <Input id="aufgabe-titel" value={title} onChange={e => setTitle(e.target.value)} placeholder="z. B. Rückruf Elternteil" required />
      </div>
      <FaelligkeitFeld id="aufgabe" value={faelligkeit} onChange={setFaelligkeit} />
      <ZuweisungFeld id="aufgabe-zuweisung" value={assignedUserId || undefined} users={users} onChange={setAssignedUserId} />
      <div className="grid gap-2">
        <Label htmlFor="aufgabe-beschreibung">Beschreibung</Label>
        <Textarea id="aufgabe-beschreibung" rows={4} value={description} onChange={e => setDescription(e.target.value)} placeholder="Was ist zu tun?" />
      </div>
      <div className="flex items-center justify-end gap-2">
        {onCancel && <Button type="button" variant="outline" onClick={onCancel}>Abbrechen</Button>}
        <Button type="submit" disabled={!title.trim() || !faelligkeit.datum || !assignedUserId}>Speichern</Button>
      </div>
    </form>
  );
};

export default TaskForm;
